import React, { FC } from "react";
import {
  useAppContext,
  IconLock,
  Text,
} from "@ftdr/blueprint-components-react";
import { PayPalIcon } from "../../../../../assets/icons";

export const PayPalApprovedNotification: FC = () => {
  const {
    appSettings: { localizedText },
  } = useAppContext();

  return (
    <div className="flex justify-center items-center my-4">
      <IconLock />
      <Text className="ml-1 mr-2">
        {" "}
        {localizedText(`PAYPAL_METHOD_APPROVED`)}
      </Text>
      <PayPalIcon />
    </div>
  );
};
